
export class PaymentSummaryRequestDTO {

    paymentsummaryid : number
    totalPayments : number | null
    totalCosts : number | null
    description : string

    constructor(paymentsummaryid : number, totalPayments : number | null, totalCosts : number | null, description : string) {
        this.paymentsummaryid = paymentsummaryid
        this.totalPayments = totalPayments
        this.totalCosts = totalCosts
        this.description = description
    }

}